export default __webpack_public_path__ + "3997f7a2d50fffbdf01c4047f4db9bc4.jpg";